import httpService from "./httpService";

export default {

  baoCaoTongHopReport(form) {
    return httpService.get(`/rankingReport/baoCaoTongHopReport`, {params: form});
  },

  trungBinhThangReport(form) {
    return httpService.get(`/rankingReport/trungBinhThangReport`, {params: form});
  },
}



// WEBPACK FOOTER //
// ./src/services/rankingReportService.js